import { headerTabTemplateURL } from '../../common/others/Configuration';
import rejectNonOkResponse from '../rejectNonOkResponse';

export default async (params) => {
  const response = await rejectNonOkResponse(
    fetch(headerTabTemplateURL(params), {
      // headers: {
      //   'x-requested-with': 'XMLHttpRequest',
      // },
    })
  );

  const { html } = await response.json();
  return html;
};
